import { UIHelper } from './UIHelper';

export class PromiseQueue {
    private queueEnd: Promise<void> = Promise.resolve();
    private cancelErrorGenerator: (() => never) | null = null;

    public async add<T = void>(callback: () => Promise<T>): Promise<T> {
        const queueEntry: Promise<void> = this.queueEnd;

        const {promise, resolve} = UIHelper.getPromiseCallbacks<void>();
        this.queueEnd = promise;

        await queueEntry;

        try {
            if (this.cancelErrorGenerator) {
                this.cancelErrorGenerator();
            }

            const value: T = await callback();

            if (this.cancelErrorGenerator) {
                this.cancelErrorGenerator();
            }

            return value;
        } finally {
            setTimeout(resolve, 0);
        }
    }

    /**
     * This will call the `errorGenerator` function before and after each
     * task was executed
     *
     * Note: the task, which is already running, will only be cancled after
     * its termination.
     *
     * @param errorGenerator a function witch throws an Error on every call
     */
    public async cancle(errorGenerator: () => never): Promise<void> {
        this.cancelErrorGenerator = errorGenerator;

        try {
            await this.add((): Promise<void> => {
                return Promise.resolve();
            });
        } catch (error) {
            // do nothing
        } finally {
            this.cancelErrorGenerator = null;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/PromiseQueue.ts